// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 97 ? "bsd-ui" : chunkId) + "-" + {"97":"8d43db07ab08453543ae","259":"2112c75fbd7dbdeb6b30"}[chunkId] + ".css";
};